import {Modal} from "bootstrap";

const modalElement = document.getElementById('confirm-action-modal')
if (modalElement) {
    const form = document.getElementById('confirm-action-form')
    const modal = new Modal(modalElement)
    const modalLabel = document.getElementById('confirm-action-modal-label')
    const modalBody = document.getElementById('confirm-action-modal-body')
    const defaultLabel = modalElement.dataset.defaultLabel
    Array.from(document.getElementsByClassName('confirm-action-btn')).forEach(btn => {
        btn.addEventListener('click', () => {
            form.setAttribute('action', btn.dataset.formAction)
            modalLabel.innerText = btn.dataset.modalTitle || defaultLabel
            modalBody.innerText = btn.dataset.modalText
            modal.show()
        })
    })
}
